module.exports = __webpack_public_path__ + "static/Award1-8b23054d97ec3a3f01bd760e3bcddb41.jpg";